<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Usuários'"
      :newRowmodalButtonText="'Novo usuário'"
      :tableHeader="headers"
      :tableRows="usuarios"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSizeData.modalSize"
      :isTheModalOpen="modalCustomSizeData.isOpen"
      :modalButtonText="modalCustomSizeData.buttonText"
      :modalFormTitle="modalCustomSizeData.formTitle"
      :modalType="modalCustomSizeData.modalType"
      :isLoadingRequestDisable="modalCustomSizeData.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSizeData.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeData.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSizeData.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-col cols="12">
        <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
      </v-col>

      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.nomeUsuario"
              name="nomeUsuario"
              label="Nome do Usuario"
              :rules="[rules.requerido]"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.cpf"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              :rules="[rules.requerido]"
              autocomplete="off"
              name="cpf"
              label="CPF"
            ></v-text-field>
          </v-col>
          <v-col v-if="modalCustomSizeData.isEdit" cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.emailCadastrado"
              name="email"
              label="Email Cadastrado"
              autocomplete="off"
              readonly
            ></v-text-field>
          </v-col>
          <v-col v-if="modalCustomSizeData.isEdit" cols="6">
            <v-text-field
              v-model="validaNovoEmail"
              :rules="[rules.email]"
              autocomplete="off"
              name="email"
              label="Novo Email"
            ></v-text-field>
          </v-col>
          <v-col v-if="!modalCustomSizeData.isEdit" cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.email"
              :rules="[rules.requerido, rules.email]"
              autocomplete="off"
              name="email"
              label="Cadastrar Email"
            ></v-text-field>
          </v-col>
          <v-col v-if="modalCustomSizeData.isEdit" cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.senha"
              name="senha"
              autocomplete="off"
              label="Senha"
            ></v-text-field>
          </v-col>
          <v-col v-else cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.senha"
              name="senha"
              autocomplete="off"
              label="Senha"
              :rules="[rules.requerido]"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.numeroRegistro"
              name="numeroRegistro"
              autocomplete="off"
              label="Credencial"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              :items="nivelDeAcesso"
              v-model="modalCustomSizeData.actualEdit.numeroNivel"
              autocomplete="off"
              label="Nivel do usuario"
              :rules="[rules.requerido]"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    rules: {
      requerido: (value) => !!value || "Requer o campo!",
      email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Formato de E-mail inválido.',
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    showSkeletonTable: true,

    // Variaveis para e-mail
    validaEmail: null,
    validaNovoEmail: null,
    estaValido: false,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "numeroUsuario",
      },
      {
        text: "Nome",
        value: "nomeUsuario",
      },
      {
        text: "Numero Registro",
        value: "numeroRegistro",
      },
      {
        text: "E-mail",
        value: "email",
      },
      {
        text: "CPF",
        value: "cpf",
      },
      { text: "Atualizar/Excluir", value: "actions", sortable: false },
    ],

    modalCustomSizeData: {
      modalSize: "1100",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroUsuario: null,
        numeroNivel: null,
        nomeUsuario: null,
        senha: null,
        email: null,
        emailCadastrado: null,
        cpf: null,
        numeroRegistro: null,
        descricaoTela: "usuarios",
      },
    },

    //Array populado pela função initialize
    usuarios: [],
    nivelDeAcesso: [],
  }),

  created() {
    this.initialize();
  },

  watch: {
    validaNovoEmail() {
      this.validaSeEmailExiste();
    },

    estaValido() {
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
    }
  },

  methods: {
    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     **************************************************************** */

    onDataTableInsertRow() {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = false;
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
      this.modalCustomSizeData.buttonText = "Registrar";
      this.modalCustomSizeData.formTitle = "Novo Usuario";

      this.modalCustomSizeData.actualEdit.numeroUsuario = null;
      this.modalCustomSizeData.actualEdit.numeroNivel = null;
      this.modalCustomSizeData.actualEdit.nomeUsuario = null;
      this.modalCustomSizeData.actualEdit.senha = null;
      this.modalCustomSizeData.actualEdit.email = null;
      this.modalCustomSizeData.actualEdit.cpf = null;
      this.modalCustomSizeData.actualEdit.numeroRegistro = null;
      this.validaEmail = null;
    },

    onDataTableUpdateRow(item) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = true;
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
      this.modalCustomSizeData.buttonText = "Salvar";
      this.modalCustomSizeData.formTitle = "Atualizar Usuario";

      this.modalCustomSizeData.actualEdit.numeroUsuario = item.numeroUsuario;
      this.modalCustomSizeData.actualEdit.numeroNivel = item.numeroNivel;
      this.modalCustomSizeData.actualEdit.nomeUsuario = item.nomeUsuario;
      this.modalCustomSizeData.actualEdit.senha = "";
      this.modalCustomSizeData.actualEdit.email = item.email;
      this.modalCustomSizeData.actualEdit.emailCadastrado = item.email;
      this.modalCustomSizeData.actualEdit.cpf = item.cpf;
      this.modalCustomSizeData.actualEdit.numeroRegistro = item.numeroRegistro
      this.validaNovoEmail = null;
    },

    async onDataTableDeleteRow(item) {
      try {
        await this.delete(item);
      } catch (error) {
        console.log(error);
      } finally {
        await this._listarUsuarios();
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSizeData.isButtonsDisabled = true;
        if (this.modalCustomSizeData.isEdit) {
          this.modalCustomSizeData.actualEdit.email = this.validaNovoEmail
          await this.update(this.modalCustomSizeData.actualEdit);
        } else {
          await this.insert(this.modalCustomSizeData.actualEdit);
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        await this._listarUsuarios();
        this.modalCustomSizeData.isButtonsDisabled = false;
        this.modalCustomSizeData.isOpen = false;
      }
    },

    /****************************************************************
     *                 FUNÇÕES DO COMPONENTE
     **************************************************************** */

    async validaSeEmailExiste() {
      try {
        const email = {email: this.validaNovoEmail}
        let response = await axios.post("/validaEmailUsuario", email, this.config);
        
        if (response.data) {
          this.alertaModal.texto = "O email inserido já está cadastrado no nosso banco de dados";
          this.alertaModal.tipo = 'erro';
        } else {
          this.alertaModal.tipo = null;
        }

        if(this.modalCustomSizeData.actualEdit.emailCadastrado == this.validaNovoEmail) {
          this.alertaModal.tipo = null;
        }
      } catch (error) {
        console.log(error.response);
      }
    },

    async _listarUsuarios() {
      try {
        const response = await axios.get("usuarios", this.config);
        this.showSkeletonTable = false;
        this.usuarios = response.data;
      } catch (error) {
        console.log(error.response);
      }
    },

    async _listarNivelDeAcesso() {
      try {
        const response = await axios.get("nivel", this.config);
        this.nivelDeAcesso = response.data.map(function(row){
          return {
            value: row.numeroNivel,
            text: row.nomeNivel
          }
        });
      } catch (error) {
        console.log(error.response);
      }
      
    },

    async initialize() {
      try {
        await this._listarUsuarios();
        await this._listarNivelDeAcesso();
      } catch (error) {
        console.log(error.response);
      }
    },

    async insert(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        this.modalCustomSizeData.isLoadingRequestDisable = true;
        
        await axios.post("usuarios", reciveItem, this.config);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Usuario adicionado com sucesso!"
        this.alerta.tipo = 'sucesso';

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        this.modalCustomSizeData.isLoadingRequestDisable = true;

        await axios.put("usuarios", reciveItem, this.config);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Usuario atualizado com sucesso!"
        this.alerta.tipo = 'sucesso';

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      }
    },

    async delete(reciveItem) {
      try {
        if (confirm("Você realmente deseja excluir este Usuários?")) {
          this.modalCustomSizeData.isLoadingRequestDisable = true;
          reciveItem.descricaoTela = "usuarios";

          await axios.delete("usuarios", {
            data: reciveItem,
            headers: this.config.headers
          });
          this.$socket.emit("insertLog");

          this.alerta.texto = "Usuario removido"
          this.alerta.tipo = 'sucesso';

          this.modalCustomSizeData.isLoadingRequestDisable = false;
          return true;
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        this.initialize();
      }
    },
  },
};
</script>
